var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-item-list"},_vm._l((_vm.newsItemList),function(n){return _c('news-item',{key:n,staticClass:"news-item",attrs:{"newsItemID":n}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }